export var URL_BASE_PLURI_CONNECT_TROCAR_SENHA = '/trocar-senha';
